<h1></h1>

<h1 class="h3 mb-2 text-gray-800">Formulario de Motivo de Refinamiento</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Instrucciones</h6>
    </div>
    <div class="card-body">
        <ol>
            <li>Mantener al paciente con el aligner actual/mejor ajustado</li>
            <li>Antes de tomar nuevas impresiones, quite los aditamentos existentes ya que pudieran requerirse
                nuevos/diferentes aditamentos.</li>
            <li>Envíe fotos y radiografías nuevas (requeridas) e impresiones digitales (recomendable) de las arcadas que estén
                necesitando corrección.</li>
        </ol>
        <form (ngSubmit)="f.form.valid && guardarDatos()" #f="ngForm">
            <div class="form-group">
                <label>1. Motivo de Envío</label>
                <div class="ml-3">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" id="pregunta1a" name="pregunta1" value="0"  (change)="changePregunta1('0')"
                            [(ngModel)]="refinamiento.motivoEnvio">
                        <label class="form-check-label" for="pregunta1a">Necesita mejoras de finalizado</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="pregunta1" value="1" id="pregunta1b" (change)="changePregunta1('1')"
                            [(ngModel)]="refinamiento.motivoEnvio">
                        <label class="form-check-label" for="pregunta1b">Los dientes no están siguiendo al
                            alineador</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="pregunta1" value="2" id="pregunta1c" (change)="changePregunta1('2')"
                            [(ngModel)]="refinamiento.motivoEnvio">
                        <label class="form-check-label" for="pregunta1c">Cambio al plan de tratamiento (especifique en
                            Instrucciones de Tratamiento)</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="pregunta1" value="3" id="pregunta1d" (change)="changePregunta1('3')"
                            [(ngModel)]="refinamiento.motivoEnvio">
                        <label class="form-check-label" for="pregunta1d">Paciente tiene nuevas restauraciones o trabajo
                            dental</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="pregunta1" value="4" id="pregunta1e" (change)="changePregunta1('4')"
                            [(ngModel)]="refinamiento.motivoEnvio">
                        <label class="form-check-label" for="pregunta1e">Paciente no cumplió con uso</label>
                    </div>
                    <div class="form-check">
                        <input type="radio" name="pregunta1" id="pregunta1f" class="form-check-input" value="5" (change)="changePregunta1('5')"
                            [(ngModel)]="refinamiento.motivoEnvio" />
                        <label class="form-check-label" for="pregunta1f">Otro (especifique por favor)</label>
                    </div>
                    <div class="ml-3">
                        <div class="form-group">
                            <label>Observaciones</label>
                            <textarea class="form-control" name="pregunta1OtroObs" (input)="changePregunta1Obs()"
                                [(ngModel)]="refinamiento.motivoOtroExplique"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>2. ¿Qué alineador lleva actualmente el paciente?</label>

                <div class="row">
                    <div class="col">
                        <div class="form-group form-inline">
                            <label>Nro. alineador superior (disponible 1-24)</label>
                            <input (keypress)="validateNo($event)" type="text" pattern="^\d{1,2}$"
                                class="form-control ml-1" name="nroAlineacionSuperior"
                                [(ngModel)]="refinamiento.nroAlineacionSuperior" #nroAlineacionSuperior="ngModel"
                                required maxlength="2"
                                [ngClass]="{ 'is-invalid': f.submitted && nroAlineacionSuperior.invalid }" />
                            <div *ngIf="f.submitted && nroAlineacionSuperior.invalid" class="invalid-feedback">
                                <div *ngIf="nroAlineacionSuperior.errors.pattern">El alineador superior tiene que ser un
                                    número entre 1 y 24</div>
                                <div *ngIf="nroAlineacionSuperior.errors.required">El alineador superior es requerido
                                </div>
                                <div *ngIf="nroAlineacionSuperior.errors.min">El alineador superior no puede ser menos
                                    de 1</div>
                                <div *ngIf="nroAlineacionSuperior.errors.max">El alineador superior no puede ser mayor a
                                    24</div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group form-inline">
                            <label>Nro. alineador inferior (disponible 1-24)</label>
                            <input (keypress)="validateNo($event)" type="text" pattern="^\d{1,2}$"
                                class="form-control ml-1" name="nroAlineacionInferior"
                                [(ngModel)]="refinamiento.nroAlineacionInferior" #nroAlineacionInferior="ngModel"
                                required maxlength="2"
                                [ngClass]="{ 'is-invalid': f.submitted && nroAlineacionInferior.invalid }" />
                            <div *ngIf="f.submitted && nroAlineacionInferior.invalid" class="invalid-feedback">
                                <div *ngIf="nroAlineacionInferior.errors.pattern">El alineador inferior tiene que ser un
                                    número entre 1 y 24</div>
                                <div *ngIf="nroAlineacionInferior.errors.required">El alineador inferior es requerido
                                </div>
                                <div *ngIf="nroAlineacionInferior.errors.minlength">El alineador inferior no puede ser
                                    menos
                                    de 1</div>
                                <div *ngIf="nroAlineacionInferior.errors.maxlength">El alineador inferior no puede ser
                                    mayor a
                                    24</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">Empezar Refinamiento</button>
                        <a [routerLink]="'/casos/'+casoId+'/verpaciente'" class="btn btn-link">Volver</a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>